if (!customElements.get('collection-description')) {
  customElements.define('collection-description', class extends HTMLElement {
    connectedCallback() {
      this.lead = this.querySelector('.phero__lead');
      this.button = this.querySelector('button');
      if (!this.lead || !this.button) return;
      this.desktop = window.matchMedia('(min-width: 1101px)');
      this.expanded = false;
      this.update = () => {
        this.lead.classList.remove('is-clamped');
        const limit = parseFloat(getComputedStyle(this.lead).lineHeight) * 3;
        const overflowing = this.desktop.matches && this.lead.getBoundingClientRect().height > limit + 1;
        if (!overflowing) this.expanded = false;
        this.button.hidden = !overflowing;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
        this.lead.style.setProperty('--phero-clamp', `${limit}px`);
        this.lead.classList.toggle('is-clamped', overflowing && !this.expanded);
      };
      this.toggle = () => { this.expanded = !this.expanded; this.update(); };
      this.button.addEventListener('click', this.toggle);
      this.desktop.addEventListener('change', this.update);
      // Only width changes affect wrapping; ignore our own height changes.
      let width;
      this.observer = new ResizeObserver(entries => {
        const next = entries[0].contentRect.width;
        if (next !== width) { width = next; this.update(); }
      });
      this.observer.observe(this);
      this.update();
      document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.desktop?.removeEventListener('change', this.update);
    }
  });
}
